import generateBoundary from "./utils";
import AbstractService from "./AbstractService";

class UserProfileService extends AbstractService {

  static _getUrl(partUrl) {
    return `/rest/v1${partUrl}`;
  }

  static _getUrlWithParent(partUrl) {
    return `${super._getUrl()}${partUrl}`;
  }


  static async getSubDealerGroups() {
    const url = this._getUrlWithParent(`/get-subdealer-groups`);

    const resp = await this._getResource(url);

    return {
      data: resp,
    };
  }

  static async getNavPermissions() {
    const url = this._getUrl(`/get-nav-permissions`);
    return await this._getResource(url);
  }

  static async getCustomerAdditionalSettings() {
    const url = this._getUrl(`/get-customer-additional-settings`);
    return await this._getResource(url);
  }

  static async getRulesAndPolicies() {
    const url = this._getUrl(`/get-rules-and-policies`);
    return await this._getResource(url);
  }

  static async acceptRulesAndPolicies(data) {
    const url = this._getUrl(`/accept-rules-and-policies`);
    return await this._setResource(url, {
      data
    });
  }

  static async getProfile() {
    const url = this._getUrl(`/get-profile`);
    return await this._getResource(url);
  }

  static async optSaveProfile() {
    const url = this._getUrl(`/save-profile`);
    return await this._optResource(url);
  }

  static async saveProfile(data) {
    const url = this._getUrl(`/save-profile`);
    return await this._setResource(url, {
      method: 'patch',
      headers: {
        'Content-Type': `multipart/form-data; boundary=${generateBoundary()}`,
      },
      data,
    });
  }

  static async deleteOwnAvatar() {
    const url = this._getUrl(`/delete-own-avatar`);
    return await this._setResource(url, {
      method: 'patch',
    });
  }

  static async changePassword(data) {
    const url = this._getUrl(`/change-password`);
    const resp = await this._setResource(url, {
      method: 'patch',
      data,
    });

    return resp.results;
  }

}

export default UserProfileService;


